import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { Modulo } from './models/modulo';
import { GridObject } from 'src/app/structure/model/grid-view';
import { ResponseApi } from 'src/app/structure/model/response-api';
import { ApiService } from 'src/app/structure/service/api.service';

import { ConfigsLoaderService } from 'src/app/services/configs-loader.service';



@Injectable({
  providedIn: 'root'
})
export class ModuloService {

  constructor(
        private httpClient: HttpClient,
        private api: ApiService,
        private configsLoaderService: ConfigsLoaderService
    ) { }

    getListPaged(obj: GridObject): Observable<ResponseApi> {
      return this.api.post(`Modulo/ListPaged`,obj)
          .pipe((res: any) => res,
              catchError(error => throwError(error)));
    }

    getItem(id: number): Observable<Modulo> {
      return this.api.get(`Modulo/GetById?id=${id}`)
        .pipe(map(res => <Modulo>res.data),
          catchError(error => throwError(error)));
    }

    getListFilter(filtro: string): Observable<Modulo[]> {
      const filter = filtro.length > 0 ? `?nome=${filtro}&` : '?';
      return this.httpClient.get<Modulo[]>(`${this.configsLoaderService.ApiUrl}${filter}`);
    }

    onDelete(id: number): Observable<number> {
      return this.api.delete(`Modulo/${id}`)
      .pipe((res) => res,
        catchError(error => throwError(error)));
    }


    async onSave(modulo: Modulo): Promise<any>  {
      return await this.api.asyncPost(`Modulo/Add`, modulo)
    }

    async onUpdate(modulo: Modulo): Promise<any>  {
      return await this.api.asyncPut(`Modulo/Update`, modulo)
    }



    getCombo(): Observable<Modulo[]> {
      return this.api.get(`Modulo/List`)
        .pipe(map(res => <Modulo[]>res.data),
          catchError(error => throwError(error)));
    }
}
